const Axios = require('axios')
const axios = Axios.create({
  baseURL: '/'
})
export default axios
